import { render, staticRenderFns } from "./GroundFloor.html?vue&type=template&id=6c3650fd&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./GroundFloor.scss?vue&type=style&index=0&id=6c3650fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3650fd",
  null
  
)

export default component.exports